









import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';

@Component({
  components: { PageTitle },
})
export default class AppAll extends Vue {
  private get remoteSrc() {
    return process.env.VUE_APP_APP_STORE_URL + '/shopby?hideLayout=true';
  }
}
